import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) return
  Sentry.init({
    dsn,
    sendDefaultPii: false,
    // Mail subjects/addresses appear in URLs (search) and breadcrumbs: strip them.
    beforeSend(event) {
      if (event.request?.url) event.request.url = event.request.url.split('?')[0]
      delete event.request?.cookies
      return event
    },
    beforeBreadcrumb(b) {
      if (b.category === 'ui.input' || b.category === 'console') return null
      if (b.data?.url) b.data.url = String(b.data.url).split('?')[0]
      return b
    },
  })
}
export const captureError = (e: unknown) => Sentry.captureException(e)
